<h1>{display}</h1>

<style>
	h1 {
		color: purple;
	}
</style>